module.exports = __webpack_public_path__ + "static/media/Mazaya Still 12.165e9127.webp";